'use strict';

var Immutable = require('immutable');
var _Immutable$Iterable = Immutable.Iterable;
var isIterable = _Immutable$Iterable.isIterable;
var isOrdered = _Immutable$Iterable.isOrdered;


function FacetedClassification() {
  var items = arguments.length <= 0 || arguments[0] === undefined ? Immutable.List() : arguments[0];

  var _facetsByIndex = arguments.length <= 1 || arguments[1] === undefined ? Immutable.Map() : arguments[1];

  if (!(this instanceof FacetedClassification)) {
    return new FacetedClassification(items, _facetsByIndex);
  }

  if (Array.isArray(items)) {
    items = Immutable.List(items);
  }

  if (!isOrdered(items)) {
    throw new Error("Items for a faceted classification must be an ordered iterable.");
  }

  this.items = items;
  this._facetsByIndex = _facetsByIndex;
}

Object.assign(FacetedClassification.prototype, {
  hashCode: function hashCode() {
    return this.items.hashCode() + this._facetsByIndex.hashCode();
  },
  equals: function equals(other) {
    return this.items.equals(other.items) && this._facetsByIndex.equals(other._facetsByIndex);
  },
  facets: function facets() {
    var _this = this;

    return this._facetsByIndex.map(function (values) {
      return values.map(function (itemIndices) {
        return itemIndices.map(function (i) {
          return _this.items.get(i);
        });
      });
    });
  },
  facetsByIndex: function facetsByIndex() {
    return this._facetsByIndex;
  },
  addFacet: function addFacet(name, fn) {
    var opts = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
    var multiValue = opts.multiValue;
    var facet = Immutable.Map().asMutable();

    this.items.forEach(function (item, key) {
      var result = fn(item);

      var values = multiValue ? Immutable.List(result) : Immutable.List.of(result);

      values.forEach(function (value) {
        facet.update(value, Immutable.Set(), function (set) {
          return set.asMutable().add(key);
        });
      });
    });

    return new FacetedClassification(this.items, this._facetsByIndex.set(name, facet.map(function (set) {
      return set.asImmutable();
    }).asImmutable()));
  },
  addFieldFacet: function addFieldFacet(field, opts) {
    var path = Array.isArray(field) ? field : field.split('.'),
        accessor = function accessor(d) {
      return d.getIn(path);
    };

    return this.addFacet(path.join('.'), accessor, opts);
  },
  removeFacet: function removeFacet(name) {
    return new FacetedClassification(this.items, this._facetsByIndex.delete(name));
  }
});

module.exports = FacetedClassification;